import { z } from "zod/v4-mini";

import type { PatientListMenuItems } from "@/uiKit/organisms/PatientsList/PatientListMenu.tsx";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type BGMViewKind = "downIsFuture" | "downIsPast";

export type BGMPreferences = {
  viewKind?: BGMViewKind;
};

export const bgmPreferencesSchema: Schema<BGMPreferences> = z.object({
  viewKind: cz.optional(z.literal(["downIsFuture", "downIsPast"])),
});

export type PatientListColumnId =
  | "patientNameForNurse"
  | "patientNameForDoctor"
  | "diabetes"
  | "telemonitoring"
  | "noticesForNurse"
  | "noticesForDoctor"
  | "messagesForNurse"
  | "messagesForDoctor"
  | "referentDoctor"
  | "tlsNurse"
  | "lastSeen";

const patientListColumnIdSchema = z.literal([
  "patientNameForNurse",
  "patientNameForDoctor",
  "diabetes",
  "telemonitoring",
  "noticesForNurse",
  "noticesForDoctor",
  "messagesForNurse",
  "messagesForDoctor",
  "referentDoctor",
  "tlsNurse",
  "lastSeen",
]);

export type PatientListColumnOverride = Partial<Record<PatientListColumnId, boolean>>;
export type PatientListColumnVisibility = Partial<Record<PatientListMenuItems, PatientListColumnOverride>>;

export const patientListColumnVisibilitySchema: Schema<PatientListColumnVisibility> = z.partialRecord(
  z.literal(["monitored", "pregnant", "all"]),
  z.partialRecord(patientListColumnIdSchema, z.boolean()),
);
